// extracted by mini-css-extract-plugin
export default {"left":"SideTitle_left__CLWOL","right":"SideTitle_right__ePre-"};